import {getIdToken} from "../../misc/miscUtils.ts";
import {ensureConnection} from "../../websocket/websocketUtils.ts";

export const updateEmbeddings = async (user: any, projectName: string,  fileContents: any[], batchId: string, websocketRef: any, setupWebsocketHelper: any) => {
    if (!user) return;

    try {
        const token = await getIdToken(user);
        await ensureConnection(websocketRef, setupWebsocketHelper);

        // Send the update embeddings request
        websocketRef.current.send(JSON.stringify({
            functionName: 'updateEmbeddings',
            args: {
                authToken: token,
                projectName: projectName,
                files: fileContents,
                batchId: batchId
            }
        }));
    } catch (error) {
        console.error(`Error updating embeddings: ${error}`);
    }
};